module.exports = __webpack_public_path__ + "img/cardBottomIcon.6b4cb54d.png";